<template>
	<dms-select-grid v-bind="{labelKey: 'VOZIDLOPA_ID', disabled, validationOff, span, noLabelAlign, isViewable, isClearable}" data-cy="vozidloPujcovnaSelect"
		@openGrid="openGrid()" @clear="clearClick">
		<dms-input :value="rzv" :disabled="rzvDisabled" data-cy="vozidloPujcovnaSelectSpz" label-key="SPZ" :span="10" :show-label="false" :wrapp="false"
			class="input-with-select" validation-off @update:value="$emit('update:rzv', $event)" />
		<dms-input :value="vin" disabled data-cy="vozidloPujcovnaSelectVin" label-key="KAROSERIE_NR" :span="14" :show-label="false" :wrapp="false"
			class="input-with-select" validation-off @update:value="$emit('update:vin', $event)" />
	</dms-select-grid>
</template>

<script>
import { BaseSelect, selectName } from '#components/baseSelect';

import { NAME } from '../constants';
import { apiProvider } from '../api';

export default BaseSelect.extend({
	name: selectName(NAME),
	props: {
		rzv: { type: String, default: '' },
		vin: { type: String, default: '' },
		filter: { type: Object, default: () => {} },
		isViewable: { type: Boolean, default: false },
		isClearable: { type: Boolean, default: true },
		rzvDisabled: { type: Boolean, default: undefined },
	},
	data() {
		return {
			storeObject: NAME,
			apiProvider,
			emptyObject: {
				rzv: null,
				id: null,
				vin: null,
			},
		};
	},
	methods: {
		dbToBaseMapper(data) {
			return {
				rzv: data.SPZ,
				vin: data.KAROSERIE_NR,
				id: data.VOZIDLOPA_ID,
			};
		},
	},
});
</script>
